
import CryptoJS from "crypto-js";

export default
    {
        name: 'ServiciosExtras',
        data() {
            return {

                loading: false,
                servicios_activos: [],
                dialogConfirmar: false,
                servicioSeleccionado: {
                    id: null,
                    titulo: '',
                    descripcion: '',
                    precio: 0
                },

                usuario: {},

                listaUsuarios: [],
                buscar: "",
                userSelected: null,

                campoRules: [
                    v => !!v || 'El campo es requerido',
                ],

            }
        },

        async created() {
            console.log('ServiciosExtras component created');
            await this.cargarServiciosActivos();
            if (this.usuario.rol_id === 5) {
                await this.listadoUsuarios();
            }
        },

        methods: {


            customFilter(item, queryText) {
                const nit = item.usuario.nit ? item.usuario.nit.toString().toLowerCase() : '';
                const cui = item.usuario.cui ? item.usuario.cui.toString().toLowerCase() : '';
                const primerNombre = item.usuario.primer_nombre ? item.usuario.primer_nombre.toLowerCase() : '';
                const segundoNombre = item.usuario.segundo_nombre ? item.usuario.segundo_nombre.toLowerCase() : '';
                const primerApellido = item.usuario.primer_apellido ? item.usuario.primer_apellido.toLowerCase() : '';
                const segundoApellido = item.usuario.segundo_apellido ? item.usuario.segundo_apellido.toLowerCase() : '';
                const nombreCompleto = `${primerNombre} ${segundoNombre} ${primerApellido} ${segundoApellido}`.trim();
                const query = queryText.toLowerCase();

                return (
                    nit.includes(query) ||
                    cui.includes(query) ||
                    nombreCompleto.includes(query)
                );
            },

            async listadoUsuarios() {
                try {
                    this.loading = true;
                    let r = await this.$store.state.services.gestoresService.listadoUsuarios();
                    console.log(r.data.data);
                    if (r.data.data != null) {
                        this.listaUsuarios = r.data.data;
                    }
                } catch (error) {
                    console.log(error);
                    this.$toast.info("Error al cargar los usuarios del gestor");
                } finally {
                    this.loading = false;
                }
            },

            async cargarServiciosActivos() {
                this.loading = true;
                try {
                    const response = await this.$store.state.services.usuarioService.listadoServiciosExtrasActivos();

                    this.servicios_activos = response.data.data;

                    // por cada elemetno agrega una variable que se llame show
                    this.servicios_activos.forEach(item => {
                        this.$set(item, 'show', false);
                    });

                    console.log('Servicios activos cargados:', this.servicios_activos);

                } catch (error) {
                    console.error('Error loading active services:', error);
                } finally {
                    this.loading = false;
                }
            },

            seleccionarServicio(servicio) {
                this.servicioSeleccionado = { ...servicio };
                this.dialogConfirmar = true;

            },

            cancelarSeleccion() {
                this.dialogConfirmar = false;
                this.servicioSeleccionado = {
                    id: null,
                    titulo: '',
                    descripcion: '',
                    precio: 0
                };
            },

            async confirmarSeleccion() {
                console.log('Confirming selection for service:', this.servicioSeleccionado);
                this.loading = true;
                try {

                    let body = {};

                    if (this.usuario.rol_id === 5 && this.userSelected) {
                        body = {
                            usuario_id: this.userSelected.usuario_id,
                            id: this.servicioSeleccionado.id,
                        };
                    } else {
                        body = {
                            usuario_id: this.usuario.id,
                            id: this.servicioSeleccionado.id,
                        };
                    }
                    console.log('Request body for user selected:', body);
                    let response = await this.$store.state.services.usuarioService.solicitarServicioExtra(body);
                    console.log('response solicitarServicioExtra', response);

                    // si no es estatus success, lanza un error
                    if (response.status !== 200) {
                        throw new Error('Error al solicitar el servicio: ' + response.data.message);
                    }

                    this.cancelarSeleccion();
                    this.$toast.success('Servicio solicitado con éxito, revisa tu correo electrónico.', {
                        position: "top-right",
                        timeout: 5000
                    });

                } catch (error) {
                    console.error('Error confirming service selection:', error);
                    this.$toast.error('Error al solicitar el servicio. Revisa tu método de pago o conexión a internet.', {
                        position: "top-right",
                        timeout: 5000
                    });
                } finally {
                    this.loading = false;
                }
            }
        },

        watch: {
            date: function (val) {
                this.dateUnformatted = val;
                this.dateFormatted = this.formatDate(val);
            },

            userSelected: function (val) {
                console.log("userSelected changed:", val);
            }
        },

        mounted() {
            console.log('ServiciosExtras component mounted');
            let informacion_incriptada = sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-todo');
            if (informacion_incriptada != null) {
                let key_pass = atob(sessionStorage.getItem('dsgfv/&#$%sdksdn..sd5454sd-tic'))
                let bytes = CryptoJS.AES.decrypt(informacion_incriptada, key_pass + "byTeamT0d0T1c");
                //Casteo de información a estring
                let informacion_desincriptada = bytes.toString(CryptoJS.enc.Utf8);
                //Casteo de JSON String a Object json
                let r = JSON.parse(informacion_desincriptada)
                // console.log("data encriptada");
                // console.log(r);
                this.usuario = r.usuario[0];
                console.log("usuario", this.usuario);

            }
        },

    }


